import { render, staticRenderFns } from "./OrganizationalStructurePage.vue?vue&type=template&id=45e794ce&scoped=true"
import script from "./OrganizationalStructurePage.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e794ce",
  null
  
)

export default component.exports